export const getDoctorName = (
  pcUserName: string,
  impersonator: string,
  displayName: string
) => {
  // There are cases where the displayName is a sentence e.g.: "Dr. Smith impersonated by Dr. John Doe"
  const isDisplayNameSentence = displayName
    .toLowerCase()
    .includes('impersonated');

  if (isDisplayNameSentence) {
    return displayName;
  }
  if (impersonator) {
    return `${displayName} impersonated by ${impersonator}`;
  }
  if (pcUserName) {
    return `${displayName} impersonated by ${pcUserName}`;
  }
  return displayName;
};
